import { createFileRoute } from "@tanstack/react-router";
import TermeniConditii from "@/pages/legal/TermeniConditii";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/termeni-si-conditii/")({
  head: () => routeHead("/termeni-si-conditii/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <TermeniConditii />
  );
}
